export const NavigationConstants = {
  LOGIN: '/login',
  DASHBOARD: '/dashboard',
  LOGOUT: '/logout'
};
